import React from "react";
import { Box, Typography, styled, Link, Grid, Stack } from "@mui/material";
import { COLORS } from "../../constants";
import { capitalize } from "lodash";

const SuggestionBlock = styled(Box)(({ theme }) => ({
  border: `1px solid ${COLORS.border}`,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  padding: "4px",
  transition: "border-color 0.3s ease",
  "&:hover": {
    borderColor: COLORS.themeRed,
  },
}));

const SearchSuggestionsBlock = ({ categoriesAndTypes, vendors = [] }) => {
  const popularSearches = [
    "DOE",
    "BETA",
    "X-APPEAL",
    "SHIELD",
    "TEKNOSA",
    "Q20",
  ];

  // Define the specific categories to display
  // Define the specific categories to display
  const selectedCategories = [
    "cooling_system",
    "service_parts",
    "brake_system",
    "oils_and_fluids",
    "sensors",
    "steering_and_suspension",
  ];

  // Custom display titles (only override the ones that need it)
  const titleOverrides = {
    steering_and_suspension: "Suspension",
  };

  const normalize = (s) => s?.toLowerCase().replace(/[\s-]+/g, "_") ?? "";

  const popularCategories = categoriesAndTypes
    .filter((category) =>
      selectedCategories.includes(normalize(category.productCategoryName)),
    )
    .map((category) => {
      const key = normalize(category.productCategoryName);
      const defaultTitle = capitalize(
        category.productCategoryName.replaceAll("_", " ").replaceAll("-", " "),
      );
      return {
        title: titleOverrides[key] || defaultTitle,
        slug: category.productCategoryId,
        image: category.productCategoryImage,
      };
    });
  return (
    <Box sx={{ display: "flex", p: 2, position: "relative" }}>
      {/* Left Section - Popular Searches */}
      <Box sx={{ flex: 1.1, mr: 2 }}>
        <Typography
          variant="caption"
          sx={{ fontWeight: 500, color: "grey", mt: 0 }}
        >
          POPULAR SEARCHES
        </Typography>
        <Stack sx={{ mt: 2 }}>
          {popularSearches.map((vendorName, index) => {
            const matched = vendors.find(
              (v) => v.name?.toUpperCase() === vendorName.toUpperCase(),
            );
            return (
              <Box key={index} sx={{ display: "block" }}>
                <Link
                  href={
                    matched
                      ? `/products/all?vendor=${matched.vendorId}`
                      : undefined
                  }
                  variant="caption"
                  sx={{
                    display: "block",
                    textDecoration: "none",
                    cursor: matched ? "pointer" : "default",
                    color: COLORS.darkText,
                    padding: 1,
                    "&:hover": {
                      color: COLORS.primary,
                      backgroundColor: matched
                        ? COLORS.themeYellow
                        : "transparent",
                      fontWeight: matched ? "bold" : "normal",
                    },
                  }}
                >
                  {vendorName}
                </Link>
              </Box>
            );
          })}
        </Stack>
      </Box>

      {/* Vertical Dividing Line */}
      <Box
        sx={{
          width: "1px",
          margin: "60px 20px 10px 0",
          backgroundColor: COLORS.border,
        }}
      />

      {/* Right Section - Popular Categories */}
      <Box sx={{ flex: 2.5 }}>
        <Typography
          variant="caption"
          sx={{
            fontWeight: 500,
            color: "grey",
            mt: 0,
            mb: 1,
            width: "100%",
          }}
        >
          POPULAR CATEGORIES
        </Typography>
        <Grid container spacing={1} sx={{ mt: 2 }}>
          {popularCategories.map((category, index) => (
            <Grid item xs={4} key={index}>
              <Link
                href={encodeURI(`/products/${category.slug}`)}
                sx={{ textDecoration: "none", color: COLORS.darkText }}
              >
                <SuggestionBlock>
                  <img
                    src={category.image}
                    alt={category.title}
                    style={{
                      width: "100%",
                      height: "80px",
                      objectFit: "contain",
                      padding: 2,
                    }}
                  />
                  <Typography
                    variant="caption"
                    sx={{
                      textTransform: "capitalize",
                    }}
                  >
                    {category.title}
                  </Typography>
                </SuggestionBlock>
              </Link>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default SearchSuggestionsBlock;
